<div class="container">
  <section class="section">
    <div class="list-grid list-header mb-4">
      <div class="page-header">
        <!-- <h1 class="page-title">{{ 'Home.Header.CourseButton' | translate }}</h1> -->
        <!-- <p class="page-subtitle">{{ totalSize }} {{ 'KnowledgeList.ItemCount' | translate }}</p> -->
      </div>
      <app-filter-toolbar
        [selectedValue]="selectedContentType"
        [(searchTerm)]="searchTerm"
        [showCategoryFilter]="true"
        [showSidenavToggle]="true"
        [placeholder]="'Global.FilterKnowledge' | translate"
        (searchTermChange)="filter()"
        (selectionChange)="onSelectionChange($event)"
        [options]="filterOptions"
      ></app-filter-toolbar>
    </div>
    @if (loading && pageIndex === 0) {
      <ui-skeleton type="courses-list" />
    } @else {
      <div class="list-grid mt-1 mb-1" id="addCourse">
        @for (course of displayedCourses; track course._id) {
          <app-course-card (shouldReload)="getCourses()" [course]="course" [isArchived]="selectedContentType === 'archive'"></app-course-card>
        }
      </div>
      @if (loading && pageIndex > 0) {
        <div class="d-flex justify-content-center p-3">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }
    }
    @if (!loading && displayedCourses?.length === 0) {
      @if (selectedContentType === 'knowledge') {
        <app-empty-content [title]="'KnowledgeList.EmptyCourseList.Title' | translate" [description]="'KnowledgeList.EmptyCourseList.Subtitle' | translate" [icon]="'description'">
          <button mat-flat-button color="primary" (click)="openCreateCourseDialog()" [hasRole]="['Admin', 'Writer']" [hasRoleAction]="'hide'">
            <mat-icon>add</mat-icon>
            {{ 'Global.Create' | translate }}
          </button>
          <button matButton="tonal" (click)="getCourses()">
            <mat-icon>refresh</mat-icon>
            {{ 'Global.Refresh' | translate }}
          </button>
        </app-empty-content>
      } @else if (selectedContentType === 'archive') {
        <app-empty-content [title]="'KnowledgeList.EmptyArchiveList.Title' | translate" [description]="'KnowledgeList.EmptyArchiveList.Subtitle' | translate" [icon]="'description'">
          <button matButton="tonal" (click)="getCourses()">
            <mat-icon>refresh</mat-icon>
            {{ 'Global.Refresh' | translate }}
          </button>
        </app-empty-content>
      }
    }
    <div #scrollObserver class="h-px w-full scroll-observer"></div>
  </section>
</div>
